var React = require('react');
var createReactClass = require('create-react-class');
var PropTypes = require('prop-types');

var SearchResultMessage = createReactClass({
	handleCoachMatchClick: function(e) {},

	render: function() {
		var message = '';

		switch (this.props.numberOfResults) {
			case 0:
				message = '0 results. Try broadening your search criteria';
				break;
			case 1:
				message = '1 result matches your search criteria';
				break;
			default:
				message =
					(this.props.totalHits > 100 ? 'Over 100' : this.props.numberOfResults) +
					' results match your search criteria';
		}

		return (
			<div className="search-result-message row">
				<span className="columns small-12 medium-6">{message}</span>
				<span className="hide-for-small-only columns medium-6 text-right">
					Need Help? Try our{' '}
					<a className="u-text-tp-blue" id="coach-match" href={this.props.coachMatchUrl} onClick={this.handleCoachMatchClick}>
						Coach Match Service
					</a>
				</span>
			</div>
		);
	}
});

module.exports = SearchResultMessage;
